import { Building2, ShowerHead, Clock, Users, HeartHandshake, Route } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, GoldButton } from "@/components/ui-kit";
import { PageHero, FinalCTA } from "@/components/blocks";
import { images } from "@/data/site";

const blocks = [
  { icon: Building2, title: "Ambienti ampi e organizzati", text: "Spazi progettati per allenarti con libertà, ordine e sicurezza, in ogni area della palestra." },
  { icon: ShowerHead, title: "Spogliatoi, docce, armadietti e parcheggio", text: "Servizi curati e comodi per vivere l'allenamento senza pensieri, prima e dopo la sessione." },
  { icon: Clock, title: "Apertura H24 da settembre", text: "La libertà di allenarti quando vuoi, ogni giorno, con la flessibilità che la tua vita richiede." },
  { icon: Users, title: "Staff presente", text: "Istruttori e personale reali in sede, pronti a seguirti con competenza e disponibilità." },
  { icon: HeartHandshake, title: "Accoglienza e attenzione ai bisogni", text: "Ti ascoltiamo per capire i tuoi obiettivi e costruire l'esperienza più adatta a te." },
  { icon: Route, title: "Percorsi personalizzati", text: "Ogni cliente segue una linea di lavoro pensata sulle proprie esigenze e sui propri traguardi." },
];

export default function LaPalestra() {
  return (
    <>
      <Seo title="La Palestra a Lusciano | Body Evolution 2.0" description="Body Evolution 2.0: una palestra moderna e accogliente a Lusciano, con ambienti curati, staff presente e percorsi personalizzati." />
      <PageHero label="La Palestra" title="La palestra a Lusciano pensata intorno a te" image={images.reception}
        text="Body Evolution 2.0 è uno spazio dedicato all'allenamento, al benessere e alla crescita personale. Una palestra moderna e accogliente, progettata per offrire ambienti curati, puliti e funzionali, dove ogni cliente può sentirsi seguito e supportato." />

      <section className="bg-ivory py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel>Cosa troverai</SectionLabel></Reveal>
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {blocks.map((b, i) => (
              <Reveal key={b.title} delay={(i % 3) * 0.08}>
                <div className="lift h-full bg-white border border-black/10 rounded-sm p-8 hover:border-gold">
                  <b.icon className="text-gold" size={28} strokeWidth={1.5} />
                  <h3 className="mt-5 font-display text-xl font-medium text-ink-800">{b.title}</h3>
                  <p className="mt-3 text-ink-800/60 text-sm leading-relaxed">{b.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}><div className="mt-14"><GoldButton to="/contatti">Vieni a trovarci in sede</GoldButton></div></Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
